export const CLEAR_LOGIC_JUMP = 'clearLogicJumpData';
export const SHOW_LOGIC_JUMP = 'showLogicJump';
export const SET_LOGIC_JUMP_ITEMS = 'setLogicJumpItems';
export const SET_LOGIC_JUMP_CONTENT_TYPE = 'setLogicJumpContentType';
export const SET_LOGIC_JUMP_ERRORS = 'setLogicJumpErrors';
export const SET_LOGIC_JUMP_VALIDATED = 'setLogicJumpValidated';
export const SET_LOGIC_JUMP_LOADING = 'setLogicJumpLoading';
